module.exports = __webpack_public_path__ + "flags.9c74e172f87984c48ddf5c8108cabe67.png";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/images/flags.png
// module id = 35
// module chunks = 0